import type { OpenClawApp } from "./app.ts";
import { loadDebug } from "./controllers/debug.ts";
import { loadLogs } from "./controllers/logs.ts";
import { loadNodes } from "./controllers/nodes.ts";

type PollingHost = {
  nodesPollInterval: number | null;
  dashboardPollInterval: number | null;
  logsPollInterval: number | null;
  debugPollInterval: number | null;
  connected?: boolean;
  tab: string;
  handlePmosRefreshConnectors?: () => Promise<void>;
  handlePmosApFlowsLoad?: () => Promise<void>;
  handlePmosApRunsLoad?: () => Promise<void>;
};

export function startNodesPolling(host: PollingHost) {
  if (host.nodesPollInterval != null) {
    return;
  }
  host.nodesPollInterval = window.setInterval(
    () => void loadNodes(host as unknown as OpenClawApp, { quiet: true }),
    5000,
  );
}

export function stopNodesPolling(host: PollingHost) {
  if (host.nodesPollInterval == null) {
    return;
  }
  clearInterval(host.nodesPollInterval);
  host.nodesPollInterval = null;
}

export function startDashboardPolling(host: PollingHost) {
  if (host.dashboardPollInterval != null) {
    return;
  }
  host.dashboardPollInterval = window.setInterval(() => {
    if (host.tab !== "dashboard" || host.connected === false) {
      return;
    }
    void Promise.all([
      host.handlePmosRefreshConnectors?.(),
      host.handlePmosApFlowsLoad?.(),
      host.handlePmosApRunsLoad?.(),
    ]);
  }, 8000);
}

export function stopDashboardPolling(host: PollingHost) {
  if (host.dashboardPollInterval == null) {
    return;
  }
  clearInterval(host.dashboardPollInterval);
  host.dashboardPollInterval = null;
}

export function startLogsPolling(host: PollingHost) {
  if (host.logsPollInterval != null) {
    return;
  }
  host.logsPollInterval = window.setInterval(() => {
    if (host.tab !== "logs") {
      return;
    }
    void loadLogs(host as unknown as OpenClawApp, { quiet: true });
  }, 2000);
}

export function stopLogsPolling(host: PollingHost) {
  if (host.logsPollInterval == null) {
    return;
  }
  clearInterval(host.logsPollInterval);
  host.logsPollInterval = null;
}

export function startDebugPolling(host: PollingHost) {
  if (host.debugPollInterval != null) {
    return;
  }
  host.debugPollInterval = window.setInterval(() => {
    if (host.tab !== "debug") {
      return;
    }
    void loadDebug(host as unknown as OpenClawApp);
  }, 3000);
}

export function stopDebugPolling(host: PollingHost) {
  if (host.debugPollInterval == null) {
    return;
  }
  clearInterval(host.debugPollInterval);
  host.debugPollInterval = null;
}
